<header-govbr></header-govbr>

  <!-- LOGIN -->
  <section class="login_plataforma_conviva" aria-labelledby="login-title">
    <div class="container">
      <div class="form-login"  data-aos="zoom-in">
        <a href="javascript:void(0)" class="logo-conviva" aria-label="Logo da Plataforma Conviva">
          <img src="../../../assets/img/logo-conviva-sp.svg" alt="" />
        </a>
        <a href="javascript:void(0)" class="btn_gov_br" (click)="loginGovBr()" aria-label="Entrar com Gov.br">
          <img src="../../../assets/img/icons/icon-entrar.svg" alt="">
          Entrar com Gov.br
        </a>
        <a href="https://www.saopaulo.sp.gov.br/" target="_blank" class="logo-gov-sp" aria-label="Ir para o site do Governo de São Paulo">
          <img src="../../../assets/img/logo-sp-gov-br.svg" alt="Logo do Governo de São Paulo" />
        </a>
      </div>
    </div>
  </section>
